import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { LangSwitcher } from "@/components/LangSwitcher";

export const Wordmark = ({ brand, to = "/" }) => (
  <Link to={to} className="flex shrink-0 items-center gap-3" data-testid="brand-wordmark">
    <span className="relative grid h-8 w-8 shrink-0 place-items-center">
      <span className="absolute h-2 w-2 rounded-full bg-vox-bright animate-breathe" />
      <span className="h-8 w-8 rounded-full border border-vox-accent/50" />
    </span>
    <span className="whitespace-nowrap font-sans text-lg font-bold tracking-tight text-vox-text">{brand}</span>
  </Link>
);

export function Nav() {
  const { user, config, logout } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/");
  };
  const linkCls = ({ isActive }) => `link-nav ${isActive ? "active" : ""}`;
  return (
    <header className="sticky top-0 z-40 border-b border-vox-line bg-vox-bg/95 backdrop-blur-xl" data-testid="main-nav">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-3 px-4 sm:px-6">
        <div className="flex items-center gap-8">
          <Wordmark brand={config.brand} to="/dashboard" />
          {user && (
            <nav className="hidden items-center gap-1 md:flex">
              <NavLink to="/dashboard" className={linkCls} data-testid="nav-link-dashboard">{t("nav.dashboard")}</NavLink>
              <NavLink to="/contacts" className={linkCls} data-testid="nav-link-contacts">{t("nav.contacts")}</NavLink>
              <NavLink to="/org" className={linkCls} data-testid="nav-link-org-settings">{t("nav.org")}</NavLink>
              <NavLink to="/account" className={linkCls} data-testid="nav-link-account">{t("nav.account")}</NavLink>
              {user.role === "platform_admin" && (
                <NavLink to="/admin" className={linkCls} data-testid="nav-link-platform-admin">{t("nav.admin")}</NavLink>
              )}
            </nav>
          )}
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <LangSwitcher compact />
          {user && (
            <div className="flex items-center gap-2 sm:gap-3" data-testid="user-menu-dropdown">
              <Link to="/account" className="hidden text-right sm:block" data-testid="user-menu-account-link">
                <div className="text-sm leading-tight text-vox-text" data-testid="user-name">{user.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-vox-dim" data-testid="user-role">{t(`org.roles.${user.role}`)}</div>
              </Link>
              <button type="button" onClick={onLogout} className="btn-ghost !px-3 !py-2" data-testid="logout-button" title={t("nav.logout")}>
                <LogOut size={16} />
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
